import React, { useEffect, useRef, useState } from 'react';
import { BREAKPOINT } from './NavigationItem';

const MenuUser = ({ content }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const projectElements = containerRef.current?.querySelectorAll(
            '.user-project'
        );
        projectElements?.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.stopPropagation(); // Prevent click from bubbling to document
                if (window.innerWidth > BREAKPOINT) {
                    setIsMenuOpen(!isMenuOpen);
                } else {
                    const navbarMenu = document.querySelector(
                        '.navbar__menu--level1'
                    );
                    navbarMenu?.classList.add('navbar__menu--show');

                    const userMenu = navbarMenu.querySelector(
                        '.user-menu-button .navbar__menu'
                    );
                    userMenu?.classList.add('navbar__menu--show');
                }
            });
        });

        const handleClickOutside = (event) => {
            if (
                containerRef.current &&
                !containerRef.current
                    .querySelector('.menu-user__nav')
                    ?.contains(event.target)
            ) {
                setIsMenuOpen(false);
            }
        };

        if (isMenuOpen) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            projectElements?.forEach((element) => {
                element.removeEventListener('click', () => {});
            });
            document.removeEventListener('click', handleClickOutside);
        };
    }, [content, isMenuOpen]);

    return (
        <div
            ref={containerRef}
            className={isMenuOpen ? 'show-menu' : ''}
            dangerouslySetInnerHTML={{ __html: content }}
        ></div>
    );
};

export default MenuUser;
